import React, { useState, useEffect, forwardRef, useImperativeHandle } from 'react';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';

const animatedComponents = makeAnimated();

export const SelectAssunto = forwardRef(({ onChange }, ref) => {
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [options, setOptions] = useState([]);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_BASE_URL}/listar-assuntos`)
      .then(response => response.json())
      .then(data => {
        const mappedOptions = data.map(item => ({
          value: item.id,
          label: item.descricao
        }));
        setOptions(mappedOptions);
      })
      .catch(error => {
        console.error('Erro ao obter as opções:', error);
      });
  }, []);

  const handleSelectionChange = (selected) => {
    setSelectedOptions(selected);
    onChange(selected);
  };

  const resetSelect = () => {
    setSelectedOptions([]);
  };

  useImperativeHandle(ref, () => ({
    resetSelect: resetSelect
  }));

  return (
    <Select
      closeMenuOnSelect={false}
      components={animatedComponents}
      value={selectedOptions}
      isMulti
      options={options}
      onChange={handleSelectionChange}
      placeholder={<div>Selecione...</div>}
    />
  );
});
